export class ProductUpsertModel {
  ID: string;
  Status: string;
  Type: string;
  Make: string;
  Model: string;
  AssetType: string;
  RequiresAudit: string;
  LineOfService1: string;
  LineOfService2: string;
  LineOfService3: string;
  LineOfService4: string;
  LineOfService5: string;
  LaborWarrantyDays?: number;
  PartWarrantyDays?: number;
  Issues: string;
  Column: string[];
}
